export default "__VITE_ASSET__ekvZkafc__"